/**
 * Configuración compartida de i18n frontend.
 *
 * DECISIÓN: URL fija sin `[locale]` prefix — el locale vive en la cookie
 * `NEXT_LOCALE`, sincronizada con `User.locale` al login. Cero renombres de
 * rutas (`/spaces`, `/conformity`, `/aviso-legal` se quedan tal cual). Copy
 * cambia según preferencia.
 */

export const SUPPORTED_LOCALES = ["es", "en"] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: Locale = "es";
export const LOCALE_COOKIE = "NEXT_LOCALE";

/** Etiquetas mostradas en el selector de idioma. */
export const LOCALE_LABELS: Record<Locale, string> = {
  es: "Español",
  en: "English",
};

/** Bandera / abreviatura corta para el chip del navbar. */
export const LOCALE_SHORT: Record<Locale, string> = {
  es: "ES",
  en: "EN",
};

export function isSupportedLocale(v: unknown): v is Locale {
  return typeof v === "string" && (SUPPORTED_LOCALES as readonly string[]).includes(v);
}

/**
 * Normaliza un input crudo ("en-US", "ES", " es ") al locale canónico o
 * devuelve `null` si no es soportado.
 */
export function normalizeLocale(raw: string | null | undefined): Locale | null {
  if (!raw) return null;
  const base = raw.trim().toLowerCase().split(/[-_]/)[0];
  return isSupportedLocale(base) ? (base as Locale) : null;
}
